export function shouldInitializeStoresModal(): boolean {
    return (
        location.pathname.startsWith('/stores') ||
        location.pathname.startsWith('/experiments')
    );
}
